(function($) {
    $(() => {

        $(document).click(function(event){
            if (!$(event.target).hasClass('link')) {
                $("#content").removeClass("mobile-open");
            }
        });

        $('.js-megamenu-opener').on('click', function(e) {
            e.preventDefault();
            const megamenuId = $(this).data('opener');

            $('.megamenu').each(function() {
                if($(this).attr('id') !== megamenuId) {
                    $(this).removeClass('opened')
                }
            });

            $('.megamenu-opener').each(function() {
                if($(this).data('opener') !== megamenuId) {
                    $(this).find('.megameu-arrow').removeClass('active');
                    $(this).removeClass('active');
                }
            });


            $(`#${megamenuId}`).toggleClass('opened');
            $(this).find('.megameu-arrow').toggleClass('active');
            $(this).toggleClass('active');
        });

        $(document).on('click', function(event){
            if (!$(event.target).hasClass('js-megamenu-opener')) {
                $('#menu').find('.active').removeClass('active');
                $('#menu').find('.opened').removeClass('opened');
            }
        });
       
        $(window).on('scroll', function(){
            $('#menu').find('.active').removeClass('active');
            $('#menu').find('.opened').removeClass('opened');
            $('#menu').find('.open').removeClass('open');
        })
    });
})(jQuery);
